<span [class]="'shared-pill shared-pill--' + status"
  ><ng-content></ng-content
></span>
